module.exports = __webpack_public_path__ + "img/lyricly.abc3db6c.jpg";